
import { Conversation } from "@/models/chat/conversation";
import { Thread } from "@/models/chat/thread";
import { ChatService } from "@/services/chat-service";
import { ChatState } from "@/utils/chat-state";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			threads: [] as Thread[],
			thread: new Thread(),
			subject: ""
		};
	},
	props: {
		state: {
			type: Object as () => ChatState,
			required: true
		}
	},
	computed: {
		sortedThreads(): Thread[] {
			return this.threads.slice().sort(function(a: Thread, b: Thread) {
				return (a.Pinned < b.Pinned) ? 1 : -1;
			});
		}
	},
	watch: {
		"state.conversationUnreads"() {
			let _ = this;
			this.threads.map(function(u: Thread) {
				let unread = _.state.conversationUnreads.find(f => (f.ConversationID == u.ConversationID));
				if (unread) {
					u.Unread = unread.Count;
				}
			});
		}
	},
	methods: {
		pin(t: Thread) {
			t.Pinned = !t.Pinned;
			ChatService.pinThread(t);
		},
		async addThread() {
			//this.threads.push({text:this.subject});
			await ChatService.createThread(this.thread, new Conversation());
			this.thread.Title = "";
			this.fetch();
		},
		async fetch() {
			this.threads = await ChatService.getThreads();
			this.state.totalThreads = this.threads.length;
		},
		complete(t: Thread) {
			t.Closed = !t.Closed;
			ChatService.updateThread(t);
		},
		open(id: number) {
			this.$router.push(`/chat/thread/` + id);
		}
	},
	created() {
		this.fetch();
	},
	components: {},
	i18nEx: {
		componentPrefix: "views.ChatThread"
	}
});
